import ProxyPage from './ProxyPage'
export default ProxyPage
